<template>
  <div class="input-group-radio" :class="classes">
    <label v-if="label">
      <span v-if="label" v-html="label" />
      <Icon v-if="forReport" name="fieldsSAV" />
      <Icon v-if="forState" name="fieldsState" />
      <Tooltip v-if="tooltip" icon="info" :content="tooltip" />
    </label>
    <div>
      <Radio
        v-for="(option, idx) in options"
        :key="`input-group-radio-item-${idx}`"
        :value="option.value"
        :label="option.label"
        :checked.sync="ivalue"
        :vuelidate="vuelidate"
        :class="{ changed: changed !== null && option.value === value }"
      />
    </div>
    <template v-if="hasChanges">
      <button class="adopt" @click.stop.prevent="handleAdopt(true)">{{ $t('review.diff.adopt') }}</button>
      <button class="adopt" @click.stop.prevent="handleAdopt(false)">{{ $t('review.diff.ignore') }}</button>
    </template>
  </div>
</template>

<script>
  import Radio from '@/components/ui/inputs/Radio';
  import Icon from '@/components/ui/Icon';
  import Tooltip from '@/components/ui/Tooltip';

  export default {
    name: 'RadioGroup',
    components: {
      Tooltip,
      Icon,
      Radio,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      label: {
        type: String,
        default: null,
      },
      tooltip: {
        type: String,
        default: null,
      },
      options: {
        type: Array,
        default: null,
      },
      value: {
        type: [Boolean, Number, String],
        default: null,
      },
      changed: {
        type: [Boolean, Number, String],
        default: null,
      },
      forState: {
        type: Boolean,
        default: false,
      },
      forReport: {
        type: Boolean,
        default: false,
      },
      vuelidate: {
        type: Object,
        default: null,
      },
      reviewMode: {
        type: Boolean,
        default: false,
      },
      //----------------------------------
      // CSS Related Properties
      //----------------------------------
      classes: {
        type: Array,
        default: () => [],
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
        ivalue: this.value,
        preventUpdate: false,
      };
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      hasChanges() {
        return this.reviewMode && this.changed !== null;
      },
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {
      value: {
        handler(val) {
          this.ivalue = val;
        },
        immediate: true,
        deep: true,
      },
      ivalue(val) {
        if (!this.preventUpdate) {
          this.$emit('update:value', val);
          this.$emit('input', val);
        }
      },
    },
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    mounted() {
      if (this.reviewMode && this.changed !== null) {
        this.preventUpdate = true;
        this.ivalue = this.changed;
        this.$nextTick(() => {
          this.preventUpdate = false;
        });
      }
    },
    // beforeUpdate() {},
    updated() {
      if (this.reviewMode && this.changed === null) {
        this.preventUpdate = true;
        this.ivalue = this.value;
        this.$nextTick(() => {
          this.preventUpdate = false;
        });
      }
    },
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      //----------------------------------
      // Event Handlers
      //----------------------------------
      handleAdopt(accept) {
        this.$emit('adopt', { accept, value: this.ivalue });
      },
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.input-group-radio {
  & > label {
    display: block;
    @include font-body-medium;
    color: $color-black-solid-100;
    margin-bottom: 4px;

    & > svg {
      position: relative;
      top: 2px;
      width: 14px;
      height: 14px;
      margin-left: 4px;
    }

    & > .comp-tooltip {
      margin-left: 8px;
    }
  }
  & > div {
    padding: 8px;
    border: 1px solid $color-black-solid-05;
    & > div {
      display: block;
      margin-bottom: 12px;
      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }

  & > button.adopt {
    display: inline-block;
    outline: 0;
    border: 0;
    cursor: pointer;
    background: transparent;
    text-decoration: underline;
    margin: 8px 0 0;
    @include font-body-small;
    color: $color-black-alpha-60;
  }

  /* -------------------------------
  Additional Styles
  ------------------------------- */
  &.three-columns {
    & > div { column-count: 3; }
  }
  &.two-columns {
    & > div { column-count: 2; }
  }
  &.flex-thirds {
    & > div {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: wrap;
      & > div {
        width: 33.33%;
      }
    }
  }
  &.flex-thirds {
    & > div {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: wrap;
      & > div {
        width: 50%;
      }
    }
  }

  &.noborder {
    & > div {
      border: 0;
    }
  }
  &.noicons {
    & > label {
      & > svg {
        display: none;
      }
    }
  }
}
</style>
